module.exports = __webpack_public_path__ + "/static/assets/385aa4b73a425883b4f9e91501a52299.svg";